/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdmissionTemplateDto } from '../models/AdmissionTemplateDto';
import type { AdmissionTemplateRequest } from '../models/AdmissionTemplateRequest';
import type { Page_AdmissionTemplateDto_ } from '../models/Page_AdmissionTemplateDto_';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdmissionTemplateControllerService {
  /**
   * getAdmissionTemplates
   * @returns Page_AdmissionTemplateDto_ OK
   * @throws ApiError
   */
  public static getAdmissionTemplatesUsingGet({
    limit,
    offset,
    search,
    type,
  }: {
    limit?: number;
    offset?: number;
    /**
     * search
     */
    search?: string;
    /**
     * type
     */
    type?: 'DOCUMENT' | 'EMAIL';
  }): CancelablePromise<Page_AdmissionTemplateDto_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/admission-templates',
      query: {
        limit: limit,
        offset: offset,
        search: search,
        type: type,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * createAdmissionTemplate
   * @returns AdmissionTemplateDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static createAdmissionTemplateUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: AdmissionTemplateRequest;
  }): CancelablePromise<AdmissionTemplateDto | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/admission-templates',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getAdmissionTemplate
   * @returns AdmissionTemplateDto OK
   * @throws ApiError
   */
  public static getAdmissionTemplateUsingGet({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<AdmissionTemplateDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/admission-templates/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * updateAdmissionTemplate
   * @returns AdmissionTemplateDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static updateAdmissionTemplateUsingPut({
    id,
    request,
  }: {
    /**
     * id
     */
    id: string;
    /**
     * request
     */
    request: AdmissionTemplateRequest;
  }): CancelablePromise<AdmissionTemplateDto | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/admission-templates/{id}',
      path: {
        id: id,
      },
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * deleteAdmissionTemplate
   * @returns any OK
   * @throws ApiError
   */
  public static deleteAdmissionTemplateUsingDelete({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/admission-templates/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
}
